import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { sortArrayBy } from '@domain-group/javascript-utils'
import { useLoadMore, useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const watchEntityKeys = ['fonts']

const useFonts = (options = {}) => {
  const { filters } = options
  const { font_family_id: filterFontFamilyId } = filters || {}

  const {
    updatedEntities: { fonts: fontsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const fonts = useSelector(reduxState => reduxState.entities.fonts)

  const filteredFonts = useMemo(() => {
    const filtered = Object.values(fonts).filter((font) => {
      const { font_family_id } = font

      const matchFontFamilyId = font_family_id === filterFontFamilyId

      return matchFontFamilyId
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [fontsUpdatedAt, JSON.stringify(filters)])

  const filteredFontsCount = filteredFonts.length
  const hasFilteredFonts = !!filteredFontsCount

  const loadMorePayload = useLoadMore({
    filters,
    loadedCount: filteredFontsCount,
    performHttpRequests: options.performHttpRequests,
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filtersWithOffset,
    limit,
    performHttpRequests,
  } = loadMorePayload

  const { loading: loadingFonts } = useReduxAction(
    'fonts',
    'loadFonts',
    {
      ...defaultRequestOptions.font,
      ...filtersWithOffset,
      limit,
    },
    [filtersWithOffset, performHttpRequests],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  return {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredFonts,
    hasFilteredFonts,
    loading: loadingFonts,
  }
}

export default useFonts
